import { IFaqItem } from "./models/faqModels";

export const NOTIFICATIONS_FAQ_ID = "why-no-notifications";

// Хардкоднато съдържание за момента — в бъдеще ще се конфигурира от всеки обект.
export const faqItems: IFaqItem[] = [
  {
    id: "how-to-cancel-reservation",
    question: "Как да откажа резервация?",
    answer: (
      <>
        <ol>
          <li>Влезте в профила си и отворете „Моите резервации“ от менюто.</li>
          <li>
            Намерете резервацията, която искате да откажете, и кликнете върху
            нея, за да видите детайлите.
          </li>
          <li>
            Натиснете бутона „Канселиране на резервацията“ и потвърдете
            отказването.
          </li>
        </ol>
        <p>
          <strong>Важно:</strong> Срокът за отказване зависи от политиката на
          обекта — някои обекти позволяват отказване само до определен брой
          часове преди началото. Ако срокът е изтекъл или онлайн отказването не
          е разрешено, свържете се директно с обекта.
        </p>
      </>
    ),
  },
  {
    id: "late-cancellation",
    question: "Какво се случва, ако откажа резервация твърде късно?",
    answer: (
      <>
        <p>
          Ако откажете навреме, посещението не се отчита и мястото се
          освобождава за други клиенти. При отказване след крайния срок,
          в зависимост от политиката на обекта:
        </p>
        <ul>
          <li>
            може да не успеете да откажете онлайн и да се наложи да се свържете
            с обекта по телефон;
          </li>
          <li>
            може да бъде начислена такса за късно отказване или посещението да
            бъде приспаднато от абонамента ви.
          </li>
        </ul>
        <p>
          При извънредни обстоятелства се свържете директно с обекта.
        </p>
      </>
    ),
  },
  {
    id: "how-to-register",
    question: "Как да се регистрирам в системата?",
    answer: (
      <>
        <ol>
          <li>
            Отворете страницата за вход и регистрация, въведете телефонния си номер и
            натиснете „Напред“.
          </li>
          <li>
            Системата ще разпознае, че нямате профил, и ще ви покаже форма за
            регистрация — попълнете имейл адрес и имената си.
          </li>
          <li>Приемете задължителните условия за ползване и продължете.</li>
          <li>
            Системата ще поиска шестцифрен код, който ще получите на имейла си. Ако сте сгрешили имейл адреса си при регистрация, моля свържете се с обекта за съдействие.
          </li>
        </ol>
        <p>
          <strong>Съвет:</strong> Ако не виждате имейла, проверете папка СПАМ.
          След това влизате с телефонния си номер и паролата.
        </p>
      </>
    ),
  },
  {
    id: "where-are-my-reservations",
    question: "Къде мога да видя моите резервации?",
    answer: (
      <p>
        След като влезете в профила си, отворете „Моите резервации“ от менюто.
        Там ще намерите всички свои предстоящи и минали резервации заедно с
        дата, час, услуга или клас и статус на всяка резервация.
      </p>
    ),
  },
  {
    id: "waiting-list",
    question: "Как работи списъкът с чакащи?",
    answer: (
      <>
        <p>
          Ако даден клас е пълен, можете да се запишете в списъка с чакащи.
          Когато се освободи място, всички чакащи получават имейл с линк за
          потвърждение едновременно — първият, който потвърди, получава
          мястото.
        </p>
        <p>
          Дали сте в списък с чакащи можете да проверите в „Моите резервации“ —
          записването ще е със статус „Списък на чакащите“.
        </p>
      </>
    ),
  },
  {
    id: "forgotten-password",
    question: "Забравих си паролата — какво да направя?",
    answer: (
      <>
        <ol>
          <li>
            На страницата за вход въведете телефонния си номер и натиснете
            „Напред“.
          </li>
          <li>Изберете „Забравена парола?“.</li>
          <li>
            Въведете имейл адреса, свързан с профила ви — ще получите имейл с
            линк за възстановяване.
          </li>
          <li>Отворете линка и задайте нова парола.</li>
        </ol>
        <p>
          <strong>Забележка:</strong> Ако използвате вход с Google, паролата се
          управлява от вашия Google акаунт. Ако не помните имейла си, свържете
          се с обекта за съдействие.
        </p>
      </>
    ),
  },
  {
    id: NOTIFICATIONS_FAQ_ID,
    question: "Защо не получавам известия?",
    answer: (
      <>
        <p>
          Известията се включват от „Моят профил“ → „Известия“, отделно за
          всяко устройство. Ако не пристигат, проверете следното:
        </p>
        <ul>
          <li>
            <strong>iPhone и iPad:</strong> известията работят само когато
            Planny е добавен на началния екран и е отворен от иконата там (iOS
            16.4 или по-нова версия). В Safari натиснете „Сподели“ → „Към
            началния екран“, отворете Planny от иконата и включете известията.
          </li>
          <li>
            <strong>Блокирани известия:</strong> ако веднъж сте ги отказали,
            браузърът не пита отново. Разрешете ги за този сайт от настройките
            на браузъра или телефона и презаредете страницата.
          </li>
          <li>
            <strong>Браузър в друго приложение:</strong> страниците, отворени
            от Instagram, Facebook, TikTok и подобни, не поддържат известия.
            Отворете Planny в Chrome, Safari или Firefox.
          </li>
          <li>
            <strong>Режим „Фокус“ или „Не безпокойте“:</strong> докато е
            включен, телефонът не показва известия. Проверете също дали
            известията за браузъра (на iPhone — за Planny) са разрешени в
            настройките на телефона.
          </li>
          <li>
            <strong>Нов телефон или изчистени данни на браузъра:</strong>{" "}
            включете известията отново от „Моят профил“ → „Известия“.
          </li>
        </ul>
        <p>
          Ако всичко изглежда наред, а известията пак не идват, свържете се с
          обекта.
        </p>
      </>
    ),
  },
];
